import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _concatInstanceProperty from "core-js-pure/stable/instance/concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { invokeWeixinJSBridgeOfPay, redirectAlipayPay } from '@ks/zt-pay-sdk';
import { getWechatPay as _getWechatPay, getAlipayInfo as _getAlipayInfo } from '../services/index';
import qs from 'qs';
import { getBrowser } from '@/utils/ua';
import { fenToYuan } from '@/utils/util';
import { publicPath } from '../env.js';
var isDebug = process.env.NODE_ENV === 'development' || process.env.TEST_ENV === 'true';
export default {
  data: function data() {
    var _context;

    var _this$$route$query = this.$route.query,
        _this$$route$query$re = _this$$route$query.redirect_url,
        redirect_url = _this$$route$query$re === void 0 ? _concatInstanceProperty(_context = "".concat(location.protocol, "//")).call(_context, location.host) || '' : _this$$route$query$re,
        _this$$route$query$me = _this$$route$query.merchant_id,
        merchant_id = _this$$route$query$me === void 0 ? '' : _this$$route$query$me,
        _this$$route$query$ti = _this$$route$query.timestamp,
        timestamp = _this$$route$query$ti === void 0 ? '' : _this$$route$query$ti,
        _this$$route$query$sc = _this$$route$query.scene,
        scene = _this$$route$query$sc === void 0 ? '' : _this$$route$query$sc,
        _this$$route$query$ve = _this$$route$query.version,
        version = _this$$route$query$ve === void 0 ? '' : _this$$route$query$ve,
        _this$$route$query$fo = _this$$route$query.format,
        format = _this$$route$query$fo === void 0 ? '' : _this$$route$query$fo,
        _this$$route$query$bi = _this$$route$query.biz_content,
        biz_content = _this$$route$query$bi === void 0 ? '' : _this$$route$query$bi,
        _this$$route$query$op = _this$$route$query.open_id,
        open_id = _this$$route$query$op === void 0 ? '' : _this$$route$query$op,
        _this$$route$query$ap = _this$$route$query.app_id,
        app_id = _this$$route$query$ap === void 0 ? '' : _this$$route$query$ap,
        store_id = _this$$route$query.store_id,
        _this$$route$query$pr = _this$$route$query.proxy_provider,
        proxy_provider = _this$$route$query$pr === void 0 ? '' : _this$$route$query$pr,
        _this$$route$query$pr2 = _this$$route$query.proxy_app_id,
        proxy_app_id = _this$$route$query$pr2 === void 0 ? '' : _this$$route$query$pr2,
        _this$$route$query$pr3 = _this$$route$query.proxy_store_id,
        proxy_store_id = _this$$route$query$pr3 === void 0 ? '' : _this$$route$query$pr3,
        _this$$route$query$tr = _this$$route$query.trade,
        trade = _this$$route$query$tr === void 0 ? '' : _this$$route$query$tr,
        _this$$route$query$co = _this$$route$query.code,
        code = _this$$route$query$co === void 0 ? '' : _this$$route$query$co,
        _this$$route$query$ms = _this$$route$query.msg,
        msg = _this$$route$query$ms === void 0 ? '' : _this$$route$query$ms;
    return {
      redirect_url: redirect_url,
      merchant_id: merchant_id,
      timestamp: timestamp,
      scene: scene,
      version: version,
      format: format,
      biz_content: biz_content,
      store_id: store_id,
      open_id: open_id,
      app_id: app_id,
      proxy_provider: proxy_provider,
      proxy_app_id: proxy_app_id,
      proxy_store_id: proxy_store_id,
      payInfo: {},
      isShowError: false,
      payResult: '充值已完成',
      trade: trade,
      code: code,
      msg: msg
    };
  },
  created: function created() {
    var ua = getBrowser();

    if (this.trade === 'error') {
      // 当后端跳转回的url中带有该参数时，需要展示错误信息
      this.isShowError = true;
      this.payResult = '交易失败';
      this.payInfo.error_msg = this.msg;
    } else if (ua === 'wechat') {
      if (!this.$route.query.open_id) {
        this.redirectWechatOAuth();
      } else {
        this.getWechatPay();
      }
    } else if (ua === 'alipay') {
      this.getAlipayInfo();
    } else {
      // 其他浏览器
      this.isShowError = true;
      this.payResult = '交易失败';
      this.payInfo.error_msg = '请使用微信或者支付宝打开';
    }

    this.$log.sendImmediately('PV', {
      type: 'enter',
      page: 'H5_KSPAY_OUTSIDE_CONFIRM',
      params: {
        product: ua === 'alipay' ? 'ALIPAY' : 'WECHAT'
      }
    });
  },
  methods: {
    fenToYuan: fenToYuan,
    getBrowser: getBrowser,
    // 微信跳转授权
    redirectWechatOAuth: function redirectWechatOAuth() {
      window.location = "/pay/order/pc/qrcode/wechat/auth?".concat(qs.stringify(this.$route.query));
    },
    // 微信内获取用户信息
    getWechatPay: function () {
      var _getWechatPay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var payInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _getWechatPay({
                  merchant_id: this.merchant_id,
                  open_id: this.open_id,
                  app_id: this.app_id,
                  store_id: this.store_id,
                  proxy_provider: this.proxy_provider,
                  proxy_app_id: this.proxy_app_id,
                  proxy_store_id: this.proxy_store_id,
                  biz_content: this.biz_content
                });

              case 2:
                payInfo = _context2.sent;
                this.payInfo = payInfo;

                if (payInfo.result === 1) {
                  if (payInfo.confirm_alert_text && payInfo.confirm_alert_text.length) {
                    this.$dialog.confirm({
                      content: payInfo.confirm_alert_text,
                      confirmText: _i18n('ok'),
                      cancelText: _i18n('cancel'),
                      onConfirm: function onConfirm() {
                        setTimeout(function () {
                          _this.orderPayWechat();
                        }, 200);
                        return;
                      },
                      onCancel: function onCancel() {
                        WeixinJSBridge.call('closeWindow'); // eslint-disable-line

                        _this.$log.sendImmediately('SHOW', {
                          action: 'PAYMENT_RESULT',
                          params: {
                            pay_status: 'CANCEL'
                          }
                        });
                      }
                    });
                  } else {
                    setTimeout(function () {
                      _this.orderPayWechat();
                    }, 200);
                  }

                  this.isShowError = false;
                } else {
                  this.isShowError = true;
                  this.payResult = '交易失败';
                  this.$log.sendImmediately('SHOW', {
                    action: 'PAYMENT_RESULT',
                    params: {
                      pay_status: 'FAIL'
                    }
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function getWechatPay() {
        return _getWechatPay2.apply(this, arguments);
      }

      return getWechatPay;
    }(),
    // 支付宝内获取用户信息
    getAlipayInfo: function () {
      var _getAlipayInfo2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var payInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _getAlipayInfo({
                  merchant_id: this.merchant_id,
                  biz_content: this.biz_content
                });

              case 2:
                payInfo = _context3.sent;
                this.payInfo = payInfo;

                if (payInfo.result === 1) {
                  if (payInfo.confirm_alert_text && payInfo.confirm_alert_text.length) {
                    this.$dialog.confirm({
                      content: payInfo.confirm_alert_text,
                      confirmText: _i18n('ok'),
                      cancelText: _i18n('cancel'),
                      onConfirm: function onConfirm() {
                        setTimeout(function () {
                          _this2.orderPayAlipay();
                        }, 200);
                        return;
                      },
                      onCancel: function onCancel() {
                        AlipayJSBridge.call('closeWebview'); // eslint-disable-line

                        _this2.$log.sendImmediately('SHOW', {
                          action: 'PAYMENT_RESULT',
                          params: {
                            pay_status: 'CANCEL'
                          }
                        });
                      }
                    });
                  } else {
                    setTimeout(function () {
                      _this2.orderPayAlipay();
                    }, 200);
                  }
                } else {
                  this.isShowError = true;
                  this.payResult = '交易失败';
                  this.$log.sendImmediately('SHOW', {
                    action: 'PAYMENT_RESULT',
                    params: {
                      pay_status: 'FAIL'
                    }
                  });
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAlipayInfo() {
        return _getAlipayInfo2.apply(this, arguments);
      }

      return getAlipayInfo;
    }(),
    // 调起微信支付
    orderPayWechat: function () {
      var _orderPayWechat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _context4, _context5, wetchatConfig, res, queryParams, finalUrl;

        return _regeneratorRuntime.wrap(function _callee3$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                wetchatConfig = JSON.parse(this.payInfo.provider_config);
                _context6.next = 4;
                return invokeWeixinJSBridgeOfPay({
                  params: {
                    appId: wetchatConfig.appId,
                    timeStamp: wetchatConfig.timeStamp,
                    nonceStr: wetchatConfig.nonceStr,
                    package: wetchatConfig.package,
                    signType: wetchatConfig.signType,
                    paySign: wetchatConfig.paySign
                  }
                }, {
                  debug: isDebug ? true : false,
                  debugOrigin: location.origin
                });

              case 4:
                res = _context6.sent;
                queryParams = {
                  out_order_no: JSON.parse(this.biz_content).out_order_no,
                  merchant_id: this.merchant_id,
                  scene: this.scene
                };
                this.$log.sendImmediately('SHOW', {
                  action: 'PAYMENT_RESULT',
                  params: {
                    pay_status: 'SUCCESS'
                  }
                });
                finalUrl = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "".concat(this.redirect_url)).call(_context5, publicPath, "/mobile-pay/payResult?")).call(_context4, qs.stringify(queryParams));
                location.replace(finalUrl);
                _context6.next = 16;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);
                this.isShowError = true;
                this.payInfo.error_msg = '如需继续交易，请重新扫码支付';

                if (_context6.t0.code === 'CANCEL') {
                  this.payResult = '支付取消';
                  this.$log.sendImmediately('SHOW', {
                    action: 'PAYMENT_RESULT',
                    params: {
                      pay_status: 'CANCEL'
                    }
                  });
                } else {
                  this.payResult = '支付失败';
                  this.$log.sendImmediately('SHOW', {
                    action: 'PAYMENT_RESULT',
                    params: {
                      pay_status: 'FAIL'
                    }
                  });
                }

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee3, this, [[0, 11]]);
      }));

      function orderPayWechat() {
        return _orderPayWechat.apply(this, arguments);
      }

      return orderPayWechat;
    }(),
    // 调起支付宝支付
    orderPayAlipay: function () {
      var _orderPayAlipay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var config, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                config = qs.parse(this.payInfo.provider_config);
                _context7.next = 4;
                return redirectAlipayPay({
                  params: {
                    app_id: config.app_id,
                    method: config.method,
                    charset: config.charset,
                    sign_type: config.sign_type,
                    sign: config.sign,
                    timestamp: config.timestamp,
                    version: config.version,
                    notify_url: config.notify_url,
                    return_url: config.return_url,
                    biz_content: config.biz_content
                  }
                }, {
                  debug: isDebug ? true : false,
                  debugOrigin: location.origin
                });

              case 4:
                res = _context7.sent;
                this.$log.sendImmediately('SHOW', {
                  action: 'PAYMENT_RESULT',
                  params: {
                    pay_status: 'SUCCESS'
                  }
                });
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);
                console.log(_context7.t0);
                this.$log.sendImmediately('SHOW', {
                  action: 'PAYMENT_RESULT',
                  params: {
                    pay_status: 'FAIL'
                  }
                });

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function orderPayAlipay() {
        return _orderPayAlipay.apply(this, arguments);
      }

      return orderPayAlipay;
    }(),
    // 关闭页面
    closePage: function closePage() {
      var ua = getBrowser();

      if (ua === 'wechat') {
        WeixinJSBridge.call('closeWindow'); // eslint-disable-line
      } else if (ua === 'alipay') {
        AlipayJSBridge.call('closeWebview'); // eslint-disable-line
      }
    }
  }
};